import { render, staticRenderFns } from "./BaseSelectInput.vue?vue&type=template&id=5a9d220f&scoped=true"
import script from "./BaseSelectInput.vue?vue&type=script&lang=js"
export * from "./BaseSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9d220f",
  null
  
)

export default component.exports